// Mock data for RepeatMD Clone

export const treatments = [
  {
    id: '1',
    name: 'Botox',
    category: 'Injectables',
    price: 12,
    priceUnit: 'per unit',
    duration: 30,
    description: 'Smooth wrinkles and fine lines with neuromodulator injections',
    image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=400',
    skinConditions: ['wrinkles', 'fine-lines', 'forehead-lines']
  },
  {
    id: '2',
    name: 'Dermal Fillers',
    category: 'Injectables',
    price: 650,
    priceUnit: 'per syringe',
    duration: 45,
    description: 'Restore volume and enhance facial contours',
    image: 'https://images.unsplash.com/photo-1616394584738-fc6e612e71b9?w=400',
    skinConditions: ['volume-loss', 'wrinkles', 'thin-lips']
  },
  {
    id: '3',
    name: 'Hydrafacial',
    category: 'Facial Treatments',
    price: 199,
    priceUnit: 'per session',
    duration: 60,
    description: 'Deep cleansing, exfoliation, and hydration treatment',
    image: 'https://images.unsplash.com/photo-1560750588-73207b1ef5b8?w=400',
    skinConditions: ['dull-skin', 'acne', 'dehydration']
  },
  {
    id: '4',
    name: 'Laser Hair Removal',
    category: 'Laser Treatments',
    price: 250,
    priceUnit: 'per session',
    duration: 30,
    description: 'Permanent hair reduction with advanced laser technology',
    image: 'https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?w=400',
    skinConditions: ['unwanted-hair']
  },
  {
    id: '5',
    name: 'Chemical Peel',
    category: 'Facial Treatments',
    price: 175,
    priceUnit: 'per session',
    duration: 45,
    description: 'Rejuvenate skin and improve texture with chemical exfoliation',
    image: 'https://images.unsplash.com/photo-1512290923902-8a9f81dc236c?w=400',
    skinConditions: ['acne-scars', 'pigmentation', 'dull-skin']
  },
  {
    id: '6',
    name: 'Microneedling',
    category: 'Skin Rejuvenation',
    price: 300,
    priceUnit: 'per session',
    duration: 60,
    description: 'Stimulate collagen production for smoother, firmer skin',
    image: 'https://images.unsplash.com/photo-1540555700478-4be289fbecef?w=400',
    skinConditions: ['acne-scars', 'wrinkles', 'texture']
  }
];

export const memberships = [
  {
    id: 'm1',
    name: 'Glow Starter',
    price: 99,
    credits: 100,
    benefits: [
      '100 monthly credits (rollover enabled)',
      '10% discount on all treatments',
      'Priority booking',
      'Birthday bonus: 50 credits'
    ],
    popular: false
  },
  {
    id: 'm2',
    name: 'Radiance Plus',
    price: 199,
    credits: 220,
    benefits: [
      '220 monthly credits (rollover enabled)',
      '15% discount on all treatments',
      'Priority booking',
      'Free monthly add-on service',
      'Birthday bonus: 100 credits'
    ],
    popular: true
  },
  {
    id: 'm3',
    name: 'Elite Beauty',
    price: 399,
    credits: 500,
    benefits: [
      '500 monthly credits (rollover enabled)',
      '20% discount on all treatments',
      'VIP priority booking',
      'Free monthly premium service',
      'Exclusive member events',
      'Birthday bonus: 200 credits'
    ],
    popular: false
  }
];

export const skinConditions = [
  { id: 'wrinkles', name: 'Wrinkles & Fine Lines', icon: '👵' },
  { id: 'acne', name: 'Acne & Breakouts', icon: '🔴' },
  { id: 'pigmentation', name: 'Dark Spots & Pigmentation', icon: '⚫' },
  { id: 'dull-skin', name: 'Dull Skin', icon: '😴' },
  { id: 'volume-loss', name: 'Volume Loss', icon: '📉' },
  { id: 'acne-scars', name: 'Acne Scars', icon: '🔹' },
  { id: 'dehydration', name: 'Dry & Dehydrated Skin', icon: '💧' },
  { id: 'texture', name: 'Rough Texture', icon: '🌊' },
  { id: 'unwanted-hair', name: 'Unwanted Hair', icon: '🪒' }
];

export const appointments = [
  {
    id: 'a1',
    patientName: 'Sarah Johnson',
    patientEmail: 'sarah.j@email.com',
    treatment: 'Hydrafacial',
    date: '2025-01-28',
    time: '10:00 AM',
    status: 'confirmed',
    provider: 'Dr. Emily Chen'
  },
  {
    id: 'a2',
    patientName: 'Michael Brown',
    patientEmail: 'mbrown@email.com',
    treatment: 'Botox',
    date: '2025-01-28',
    time: '11:30 AM',
    status: 'confirmed',
    provider: 'Dr. Emily Chen'
  },
  {
    id: 'a3',
    patientName: 'Jessica Lee',
    patientEmail: 'jlee@email.com',
    treatment: 'Laser Hair Removal',
    date: '2025-01-28',
    time: '2:00 PM',
    status: 'pending',
    provider: 'Dr. Michael Torres'
  }
];

export const providers = [
  {
    id: 'p1',
    name: 'Dr. Emily Chen',
    specialty: 'Injectables & Facial Aesthetics',
    image: 'https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=200',
    availability: ['Monday', 'Tuesday', 'Wednesday', 'Friday']
  },
  {
    id: 'p2',
    name: 'Dr. Michael Torres',
    specialty: 'Laser Treatments & Skin Rejuvenation',
    image: 'https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?w=200',
    availability: ['Tuesday', 'Thursday', 'Friday', 'Saturday']
  }
];

export const promotionalVideos = [
  {
    id: 'v1',
    title: 'Transform Your Practice with RepeatMD',
    thumbnail: 'https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=600',
    duration: '2:34',
    category: 'Platform Overview'
  },
  {
    id: 'v2',
    title: 'Membership Success Stories',
    thumbnail: 'https://images.unsplash.com/photo-1522335789203-aabd1fc54bc9?w=600',
    duration: '3:45',
    category: 'Case Study'
  },
  {
    id: 'v3',
    title: 'AI Treatment Advisor Demo',
    thumbnail: 'https://images.unsplash.com/photo-1488590528505-98d2b5aba04b?w=600',
    duration: '4:12',
    category: 'Product Demo'
  }
];

export const chatbotResponses = {
  greeting: "Hi! I'm Aria, your AI treatment advisor. I'm here to help you find the perfect treatments for your skin concerns. What are you looking to address today?",
  wrinkles: "For wrinkles and fine lines, I recommend Botox or Dermal Fillers. Botox is great for dynamic wrinkles (expression lines), while fillers restore volume. Would you like to book a consultation?",
  acne: "For acne and breakouts, our Hydrafacial treatment is excellent. It deeply cleanses pores and reduces inflammation. We also offer chemical peels for acne scarring. Shall I check available appointments?",
  general: "I can help you with treatment recommendations, booking appointments, or answering questions about our memberships. What would you like to know?"
};

export const revenueData = [
  { month: 'Jan', revenue: 45000, appointments: 120 },
  { month: 'Feb', revenue: 52000, appointments: 135 },
  { month: 'Mar', revenue: 48000, appointments: 128 },
  { month: 'Apr', revenue: 58000, appointments: 145 },
  { month: 'May', revenue: 62000, appointments: 158 },
  { month: 'Jun', revenue: 71000, appointments: 172 }
];

export const smsTemplates = [
  {
    id: 'sms1',
    name: 'Appointment Reminder',
    content: 'Hi {name}! Reminder: Your {treatment} appointment is tomorrow at {time}. Reply C to confirm or R to reschedule.',
    category: 'Reminders'
  },
  {
    id: 'sms2',
    name: 'Birthday Special',
    content: 'Happy Birthday {name}! 🎉 Enjoy 20% off any treatment this month. Book now: {link}',
    category: 'Promotions'
  },
  {
    id: 'sms3',
    name: 'Membership Rollover Alert',
    content: 'Good news {name}! Your {credits} unused credits have rolled over to next month. Book your next treatment: {link}',
    category: 'Membership'
  }
];